import { Component, OnInit, Inject } from '@angular/core';
import {   MatDialog,   MatDialogRef,   MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData{
  name: string;
}

@Component({
  selector: 'app-dialog-delete-new-member',
  templateUrl: './dialog-delete-new-member.component.html',
  styleUrls: ['./dialog-delete-new-member.component.scss']
})
export class DialogDeleteNewMemberComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteNewMemberComponent>,
    @Inject(MAT_DIALOG_DATA) public data:DialogData
  ) { }

  ngOnInit(): void {
  }

}
